import * as React from "react";
import type { SVGProps } from "react";
const SvgUnion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.8 21.6h8a2.4 2.4 0 0 0 2.4-2.4v-4h4a2.4 2.4 0 0 0 2.4-2.4v-8a2.4 2.4 0 0 0-2.4-2.4h-8a2.4 2.4 0 0 0-2.4 2.4v4h-4a2.4 2.4 0 0 0-2.4 2.4v8a2.4 2.4 0 0 0 2.4 2.4"
    />
  </svg>
);
export default SvgUnion;
